import BaseComponent from '../base-component/base-component'
import { Nullable } from '../../types/common'

interface VideoBannerOptions {
  isAutoplayEnabled: boolean
  isControlsEnabled: boolean
}

class VideoBanner extends BaseComponent {
  poster: Nullable<HTMLElement>
  options: VideoBannerOptions

  constructor() {
    super()

    this.poster = this.querySelector('[data-video-banner-poster]')
    this.options = {
      isAutoplayEnabled: this.hasAttribute('data-enable-autoplay'),
      isControlsEnabled: this.hasAttribute('data-enable-controls'),
    }
  }

  connectedCallback(): void {
    if (this.options.isAutoplayEnabled) {
      this.loadContent()
    }

    if (this.poster) {
      this.poster.addEventListener('click', this.handlePosterClick)
    }

    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback(): void {
    if (this.poster) {
      this.poster.removeEventListener('click', this.handlePosterClick)
    }

    this.removeEventListener('click', this.handleClick)
  }

  handleClick = (event: MouseEvent): void => {
    if (event.target.tagName === 'VIDEO') {
      const video = event.target

      if (!this.options.isControlsEnabled) {
        this.videoToggle(video)
      }
    }
  }

  handlePosterClick = (): void => {
    this.loadContent()
  }

  videoToggle(video): void {
    const isPaused = video.paused

    if (isPaused) {
      video.play()
    } else {
      video.pause()
    }
  }

  loadContent(): void {
    if (!this.getAttribute('loaded')) {
      this.addVideo()

      this.setAttribute('loaded', 'true')
    }
  }

  removeVideo(): void {
    const video = this.querySelector('video,  iframe')

    if (video) {
      video.remove()

      this.removeAttribute('loaded')
    }
  }

  addVideo(): void {
    const content = document.createElement('div')
    const template = this.querySelector('[data-video-banner-media-template]')
    const templateContent = template?.content
    const container = this.querySelector('[data-video-banner-container]')

    if (!templateContent || !templateContent.firstElementChild) {
      return
    }

    const firstChild = templateContent.firstElementChild.cloneNode(true)

    content.appendChild(firstChild)
    const video = content.querySelector<any>('video, iframe')

    if (!video) {
      return
    }

    if (this.poster) {
      this.poster.remove()
    }

    container.appendChild(video)

    if (video.tagName === 'VIDEO') {
      video.play()
    }
  }
}

export default VideoBanner
